import {useEffect, useState} from 'react';
import * as store from '@/store/index';
import {DOC_TYPE, IDocType} from '@/constants/document/doc';
import {useLocation} from 'react-router-dom';
import {getKnowledgePageRouteMatchInfo} from '@/utils/urlUtils';

const iconsData = {
    [DOC_TYPE.DOCUMENT]: '/doc.svg',
    [DOC_TYPE.DIRECTORY]: '/book.svg',
    [DOC_TYPE.SHEET]: '/sheet.svg',
    [DOC_TYPE.PPT]: '/ppt.svg',
    [DOC_TYPE.DATASHEET]: '/datasheet.svg',
};

const IconTypeChange = (props: {
    curDocument?: WizDocument;
}) => {
    const {curDocument} = props;
    const RuliuLogo = '/logo196.png';

    const [isDocPage, setIsDocPage] = useState(false);
    const [isCurDocId, setIsCurDocId] = useState(false);
    const [imgUrl, setImgUrl] = useState('');
    const location = useLocation();

    useEffect(() => {
        const {isDocPage, docGuid} = getKnowledgePageRouteMatchInfo();
        setIsCurDocId(docGuid === curDocument?.docGuid);
        setIsDocPage(isDocPage);
    }, [curDocument?.docGuid, location]);

    useEffect(() => {
        const url = isDocPage ?
            isCurDocId ? iconsData[curDocument?.type as IDocType] : imgUrl
            : RuliuLogo;
        setImgUrl(url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDocPage, isCurDocId, curDocument?.type]);

    useEffect(() => {
        imgUrl && document.querySelector('link[rel="shortcut icon"]')?.setAttribute(
            'href', `${process.env.PUBLIC_URL}${imgUrl}`
        );
    }, [imgUrl]);

    return null;
};

export default store.connect([
    store.KEYS.CUR_DOCUMENT,
])(IconTypeChange);
